import React, { useRef, useState, useEffect, Fragment } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  TextField,
  Avatar,
  Typography,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DescriptionIcon from '@material-ui/icons/Description';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { Formik } from 'formik';
import MaterialTable from "material-table";
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import GoodsReceivedNotePDF from './GoodsReceivedNotePDF';
import { useAlert } from 'react-alert';
import { trackPromise } from 'react-promise-tracker';
import { useNavigate } from 'react-router-dom';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import * as Yup from "yup";
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { MaskeliyaBLERPEnum } from '../../Common/MaskeliyaBLERPEnum/MaskeliyaBLERPEnum';
import services from '../Services';
import { LoadingComponent } from './../../../utils/newLoader';

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'linear-gradient(135deg, #f1f6faff 0%, #f0f5f9ff 50%, #f8fafc 100%)',
    minHeight: '100vh',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  row: {
    marginTop: '1rem'
  }
}));

const screenCode = 'GOODRECEIVEDNOTE';

const formatNumberWithThousandSeparators = (input, decimals = 2) => {
  const numericValue = Number(input);
  if (Number.isNaN(numericValue)) {
    return decimals > 0 ? `0.${'0'.repeat(decimals)}` : '0';
  }
  const fixedValue = numericValue.toFixed(decimals);
  const [integerPart, decimalPart = ''] = fixedValue.split('.');
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decimals > 0 ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};

const GoodReceiveNoteListing = () => {
  const alert = useAlert();
  const printRef = useRef();
  const classes = useStyles();
  const navigate = useNavigate();
  const printTriggerRef = useRef();
  const [selectedGRN, setSelectedGRN] = useState(null);
  const maskeliyaBLERPEnum = new MaskeliyaBLERPEnum();
  const [title, setTitle] = useState("Goods Received Note");
  const [permissionList, setPermissions] = useState({ isGroupFilterEnabled: false, isFactoryFilterEnabled: false });
  const [tableData, setTableData] = useState([]);
  const [groups, setGroups] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [purchaseOrder, setPurchaseOrder] = useState([]);
  const [dpoNumber, setDpoNumber] = useState([]);
  const [TempValu, setTempValu] = useState({
    purchaseOrderID: 0,
    purchaseOrderNumber: ""
  });
  const [goodsReceiveNote, setGoodsReceiveNote] = useState({
    groupID: 0,
    factoryID: 0,
    receivedDate: moment(new Date()).format('YYYY-MM-DD'),
    grnType: 0,
    grnStatus: 0,
    requisitionID: 0,
    purchaseNumberID: 0,
    invoiceNumber: '',
    invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
    paymentDueDate: moment(new Date()).format('YYYY-MM-DD'),
    isCredit: false,
    gtnNumberID: 0,
    warehouseID: 0,
    actionType: 0,
    dpoNumberID: 0,
  });

  const PO = maskeliyaBLERPEnum.GoodReceivedNoteStatusGRNType.PurchaseOrder;
  const DGRN = maskeliyaBLERPEnum.GoodReceivedNoteStatusGRNType.DirectGRN;
  const DPO = maskeliyaBLERPEnum.GoodReceivedNoteStatusGRNType.DirectPurchaseOrder;

  const handleClick = () => {
    const encrypted = btoa('0');
    navigate('/app/goodsReceiveNote/addEdit/' + encrypted);
  };

  useEffect(() => {
    const IDdata = JSON.parse(sessionStorage.getItem('goodsReceiveNote-listing-page-search-parameters-id'));
    trackPromise(getPermission(IDdata));
    sessionStorage.removeItem('goodsReceiveNote-listing-page-search-parameters-id');
  }, []);

  useEffect(() => {
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown());
  }, [goodsReceiveNote.groupID]);

  useEffect(() => {
    if (goodsReceiveNote.grnType === PO && goodsReceiveNote.factoryID !== 0) {
      trackPromise(getPurchaseOrderListing(goodsReceiveNote.factoryID));
    }
  }, [goodsReceiveNote.grnType, goodsReceiveNote.factoryID]);

  useEffect(() => {
    if (goodsReceiveNote.purchaseNumberID !== 0) {
      trackPromise(getRequisitionNumberForDropDown());
    }
  }, [goodsReceiveNote.purchaseNumberID]);

  useEffect(() => {
    if (goodsReceiveNote.grnType === DPO && goodsReceiveNote.groupID !== 0 && goodsReceiveNote.factoryID !== 0) {
      trackPromise(GetDirectPurchaseOrderNumbersForDropDown());
    }
  }, [goodsReceiveNote.groupID, goodsReceiveNote.factoryID, goodsReceiveNote.grnType]);

  useEffect(() => {
    setTitle(getTitleByGRNType(goodsReceiveNote.grnType));
  }, [goodsReceiveNote.grnType]);


  useEffect(() => {
    return () => {
      sessionStorage.removeItem('goodsReceiveNote-listing-page-search-parameters-id');
    };
  }, []);

  const getPermission = async (IDdata) => {
    const permissions = await authService.getPermissionsByScreen(screenCode);
    const isAuthorized = permissions.find(p => p.permissionCode === 'VIEWGOODRECEIVEDNOTE');

    if (!isAuthorized) {
      navigate('/404');
    }
    const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
    const isFactoryFilterEnabled = permissions.find((p) => p.permissionCode === 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    const initialValues = IDdata === null;
    if (initialValues) {
      setGoodsReceiveNote({
        ...goodsReceiveNote,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        factoryID: parseInt(tokenService.getFactoryIDFromToken()),
      });
    } else {
      setGoodsReceiveNote({
        ...goodsReceiveNote,
        groupID: IDdata.groupID,
        factoryID: IDdata.factoryID,
        divisionID: IDdata.divisionID,
        outsiderNo: IDdata.outsiderNo,
        fromDate: moment(IDdata.fromDate).format('YYYY-MM-DD'),
        toDate: moment(IDdata.toDate).format('YYYY-MM-DD')
      });
    }
  };

  const getTitleByGRNType = (grnType) => {
    switch (grnType) {
      case PO:
        return 'Goods Received Note - Purchase Order';
      case DGRN:
        return 'Goods Received Note - Direct GRN';
      case DPO:
        return 'Goods Received Note - Direct Purchase Order';
      default:
        return 'Goods Received Note';
    }
  };

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(goodsReceiveNote.groupID);
    setFactoryList(factories);
  }

  async function getPurchaseOrderListing() {
    const list = await services.getPurchaseOrderForListing(goodsReceiveNote.factoryID);
    setPurchaseOrder(list);
  }

  async function GetDirectPurchaseOrderNumbersForDropDown() {
    const response = await services.getDirectPurchaseOrderForListing(goodsReceiveNote.groupID, goodsReceiveNote.factoryID);
    setDpoNumber(response);
  }

  async function getRequisitionNumberForDropDown() {
    var response = await services.getRequisitionNumberForDropDown(goodsReceiveNote.purchaseNumberID);
    var newCollectionTypeArray = [];
    for (var i = 0; i < response.length; i++) {
      newCollectionTypeArray.push({ label: response[i].requisitionNumber, value: response[i].requisitionID })
    }
  };

  function handleSearchDropdownPONumber(data, e) {
    if (data === null) {
      setTempValu({
        purchaseOrderID: 0,
        purchaseOrderNumber: ""
      });
      setTableData([]);
      setGoodsReceiveNote({
        ...goodsReceiveNote,
        purchaseNumberID: 0,
        requisitionID: 0,
        invoiceNumber: '',
        invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
        paymentDueDate: moment(new Date()).format('YYYY-MM-DD'),
        gtnNumberID: 0,
      });
      return;
    }
    let list = [...purchaseOrder];
    setTempValu(data);
    const result = list.find(e => e.purchaseOrderNumber === data.purchaseOrderNumber);

    if (!result) {
      alert.error("Selected PO Number is invalid.");
      return;
    }

    setTableData([]);
    setGoodsReceiveNote({
      ...goodsReceiveNote,
      purchaseNumberID: result.purchaseOrderID,
      requisitionID: 0,
      invoiceNumber: '',
      invoiceDate: moment(new Date()).format('YYYY-MM-DD'),
      paymentDueDate: moment(new Date()).format('YYYY-MM-DD'),
      gtnNumberID: 0,
    });
  };

  const generateDropDownMenu = (data) => {
    if (!data) return [];
    return Object.entries(data).map(([key, value]) => {
      const valueString = String(value);
      const lastPart = valueString.split('/').pop();
      return (
        <MenuItem key={key} value={key}>{lastPart}</MenuItem>
      );
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'groupID') {
      setGoodsReceiveNote({
        groupID: value,
        fromDate: moment(new Date()).format('YYYY-MM-DD'),
        toDate: moment(new Date()).format('YYYY-MM-DD'),
        divisionID: 0,
        factoryID: 0,
        outsiderNo: 0,
        grnType: 0,
        sundryTask: 0,
        workingDays: 0,
        employeeName: '',
        dpoNumberID: 0,
        gtnNumberID: 0,
        purchaseNumberID: 0
      });
    } else if (name === 'factoryID') {
      setGoodsReceiveNote(prevState => ({
        ...prevState,
        factoryID: value,
        divisionID: 0,
        outsiderNo: 0,
        grnType: 0,
        sundryTask: 0,
        workingDays: 0,
        employeeName: '',
        dpoNumberID: 0,
        gtnNumberID: 0,
        purchaseNumberID: 0
      }));
    } else if (name === 'grnType') {
      setGoodsReceiveNote(prevState => ({
        ...prevState,
        grnType: value,
        outsiderNo: 0,
        field: 0,
        sundryTask: 0,
        workingDays: 0,
        employeeName: '',
        dpoNumberID: 0,
        gtnNumberID: 0,
        purchaseNumberID: 0
      }));
    } else if (name === 'outsiderNo') {
      setGoodsReceiveNote(prevState => ({
        ...prevState,
        outsiderNo: value,
        employeeName: ''
      }));
      setTableData([]);
    } else {
      setGoodsReceiveNote(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
    sessionStorage.setItem('goodsReceiveNote-listing-page-search-parameters-id', JSON.stringify({
      ...goodsReceiveNote,
      [name]: value
    }));
    setTableData([]);
  };


  async function getGoodsReceiveNoteDetails() {
    let model = {};
    if (goodsReceiveNote.grnType === PO) {
      model = {
        groupID: parseInt(goodsReceiveNote.groupID),
        factoryID: parseInt(goodsReceiveNote.factoryID),
        grnTypeID: parseInt(goodsReceiveNote.grnType) || 0,
        purchaseNumberID: parseInt(goodsReceiveNote.purchaseNumberID) || 0,
        requisitionIDs: null,
      };
    } else if (goodsReceiveNote.grnType === DGRN) {
      model = {
        groupID: parseInt(goodsReceiveNote.groupID),
        factoryID: parseInt(goodsReceiveNote.factoryID),
        grnTypeID: parseInt(goodsReceiveNote.grnType) || 0,
        gtnNumberID: parseInt(goodsReceiveNote.gtnNumberID) || 0,
      };
    } else if (goodsReceiveNote.grnType === DPO) {
      model = {
        grnTypeID: parseInt(goodsReceiveNote.grnType) || 0,
        groupID: parseInt(goodsReceiveNote.groupID) || 0,
        factoryID: parseInt(goodsReceiveNote.factoryID) || 0,
        directPurchaseOrderID: parseInt(goodsReceiveNote.dpoNumberID) || 0,
      };
    }

    const response = await services.GetGRNListingDetails(model);
    if (response.data && Array.isArray(response.data.pendingGRNDetails)) {
      const statusMap = {
        0: 'Pending',
        1: 'Partially Complete',
        2: 'Fully Complete'
      };

      let flatData = [];

      if (goodsReceiveNote.grnType === PO) {
        flatData = response.data.pendingGRNDetails.map(item => ({
          grnNumber: item.grnNumber || '-',
          groupName: item.groupName || '-',
          factoryName: item.factoryName || '-',
          receivedDate: item.purchaseDate || '-',
          supplierName: item.supplierName || '-',
          poNumber: item.poNumber || '-',
          requisitionNumber: item.requisitionNumber || '-',
          skuMasterName: item.skuMasterName || '',
          skuMasterCode: item.skuMasterCode || '',
          poQty: item.requestedQTY || 0,
          receivedQty: item.receivedQTY || 0,
          unitPrice: item.unitPrice || 0,
          discountAmount: item.discountAmount || 0,
          netAmount: item.netAmount || 0,
          status: statusMap[item.poStatus] || 'Pending',
          warehouseName: item.warehouseName || '',
          quotationNumber: item.quotationNumber || '',
          goodsReceiveNoteID: item.purchaseOrderDetailsID || '',
          budgetCodeID: item.budgetCodeID || 0,
          skuMasterID: item.skuMasterID || 0,
          requisitionID: item.requisitionID || 0,
          warehouseID: item.skuWarehouseID || 0,
          supplierID: item.supplierID || 0,
          supplierName: item.supplierName || '',
          deliveryWarehouseID: item.deliveryWarehouseID || 0,
          warehouseSKUMappingID: item.warehouseSKUMappingID || 0,
          skuCategoryID: item.skuCategoryID || 0,
          quotationHeaderID: item.quotationHeaderID || 0
        }));
      } else if (goodsReceiveNote.grnType === DGRN) {
        flatData = response.data.pendingGRNDetails.map(item => ({
          grnNumber: item.directGrnNumber || item.grnNumber || '-',
          groupName: item.groupName || '-',
          factoryName: item.factoryName || '-',
          receivedDate: '',
          supplierName: item.supplierName || '-',
          poNumber: '-',
          requisitionNumber: item.requisitionNumber || '-',
          skuMasterName: item.skuMasterName || '-',
          skuMasterCode: item.skuMasterCode || '',
          poQty: item.requestedQTY || 0,
          receivedQty: item.requestedQTYByRequisition || 0,
          unitPrice: 0,
          discountAmount: 0,
          netAmount: 0,
          status: 'Pending',
          warehouseName: item.warehouseName || '',
          quotationNumber: '',
          goodsReceiveNoteID: item.transactionHeaderID || '',
          budgetCodeID: item.budgetCodeID || 0,
          skuMasterID: item.skuMasterID || 0,
          requisitionID: item.requisitionID || 0,
          warehouseID: item.skuWarehouseID || 0,
          supplierID: item.supplierID || 0,
          supplierName: item.supplierName || '',
          toWarehouseID: item.toWarehouseID || 0,
          fromWarehouseID: item.fromWarehouseID || 0,
          deliveryWarehouseID: item.deliveryWarehouseID || 0,
          warehouseSKUMappingID: item.warehouseSKUMappingID || 0,
          skuCategoryID: item.skuCategoryID || 0,
          transactionTypeID: item.transactionTypeID || 0
        }));
      } else if (goodsReceiveNote.grnType === DPO) {
        flatData = response.data.pendingGRNDetails.map(item => ({
          grnNumber: item.grnNumber || '-',
          groupName: item.groupName || '-',
          factoryName: item.factoryName || '-',
          receivedDate: item.purchaseDate ? moment(item.purchaseDate).format('YYYY-MM-DD') : '',
          supplierName: item.supplierName || '-',
          poNumber: item.dpoNumber || '',
          requisitionNumber: '',
          skuMasterName: item.skuMasterName || '',
          skuMasterCode: item.skuMasterCode || '',
          poQty: item.requestedQTY || 0,
          receivedQty: item.receivedQTY,
          unitPrice: item.unitPrice || 0,
          discountAmount: item.discountAmount || 0,
          netAmount: item.netAmount || 0,
          status: item.dpoStatus || 'Pending',
          warehouseName: '',
          quotationNumber: '',
          goodsReceiveNoteID: item.dpoNumber || '',
          budgetCodeID: item.budgetCodeID || 0,
          skuMasterID: item.skuMasterID || 0,
          supplierID: item.supplierID || 0,
          skuCategoryID: item.skuCategoryID || 0,
          dpoTypeID: item.dpoTypeID || 0,
          headTotal: item.headTotal || 0
        }));
      }

      setTableData(flatData);
    } else {
      setTableData([]);
      alert.error('No Records Found');
    }
  }


  const searchValidationSchema = Yup.object().shape({
    groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
    factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
    grnType: Yup.number().required('GRN Type is required').min(1, 'GRN Type is required'),
  });

  const cardTitle = (titleName) => (
    <Grid container spacing={1}>
      <Grid item md={10} xs={12}>
        {titleName}
      </Grid>
      <Grid item md={2} xs={12}>
        <PageHeader
          onClick={handleClick}
          isEdit={true}
          toolTiptitle={"Edit GoodsReceiveNote Average"} />
      </Grid>
    </Grid>
  );

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Card>
            <Box>
              <Formik
                initialValues={goodsReceiveNote}
                validationSchema={searchValidationSchema}
                enableReinitialize
                onSubmit={getGoodsReceiveNoteDetails}
              >
                {({
                  errors,
                  handleBlur,
                  handleSubmit,
                  touched,
                  values,
                  setFieldValue
                }) => (
                  <form onSubmit={handleSubmit}>
                    <CardContent>
                      <Box mt={0}>
                        <CardHeader title={cardTitle(title)} />
                        <Divider />
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={goodsReceiveNote.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={goodsReceiveNote.factoryID}
                              variant="outlined"
                              size="small"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="grnType">
                              GRN Type *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.grnType && errors.grnType)}
                              fullWidth
                              helperText={touched.grnType && errors.grnType}
                              name="grnType"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={goodsReceiveNote.grnType}
                              variant="outlined"
                              id="grnType"
                              size="small"
                            >
                              <MenuItem value={0}>--Select GRN Type--</MenuItem>
                              {/* <MenuItem value={1}>Direct GRN</MenuItem> */}
                              {/* <MenuItem value={2}>Purchase Order</MenuItem> */}
                              <MenuItem value={3}>Direct Purchase Order</MenuItem>
                            </TextField>
                          </Grid>
                          {goodsReceiveNote.grnType === PO && (
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="purchaseNumberID">PO Number</InputLabel>
                              <Autocomplete
                                options={purchaseOrder && purchaseOrder.length > 0 ? purchaseOrder : [{ purchaseOrderNumber: '', purchaseOrderID: 0 }]}
                                size="small"
                                getOptionLabel={(option) => option.purchaseOrderNumber || ''}
                                onChange={(e, value) => handleSearchDropdownPONumber(value, e)}
                                value={TempValu}
                                renderInput={(params) => (
                                  <TextField {...params}
                                    fullWidth
                                    variant="outlined"
                                    placeholder="--Select PO Number--"
                                  />
                                )}
                              />
                            </Grid>
                          )}
                          {/* {goodsReceiveNote.grnType === DGRN && (
                              <Grid item md={3} xs={12}>
                                <InputLabel shrink id="gtnNumberID">GTN Number</InputLabel>
                                <TextField select
                                  fullWidth
                                  name="gtnNumberID"
                                  size="small"
                                  onChange={handleChange}
                                  value={goodsReceiveNote.gtnNumberID}
                                  variant="outlined"
                                >
                                  <MenuItem value="0">--Select GTN Number--</MenuItem>
                                  {generateDropDownMenu(gtnNumber)}
                                </TextField>
                              </Grid>
                          )} */}
                          {goodsReceiveNote.grnType === DPO && (
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="dpoNumberID">Direct Purchase Order</InputLabel>
                              <TextField select
                                fullWidth
                                name="dpoNumberID"
                                size="small"
                                onChange={handleChange}
                                value={goodsReceiveNote.dpoNumberID}
                                variant="outlined"
                              >
                                <MenuItem value="0">--Select Direct PO Number--</MenuItem>
                                {generateDropDownMenu(dpoNumber)}
                              </TextField>
                            </Grid>
                          )}
                        </Grid>

                        <Box display="flex" flexDirection="row-reverse" p={2}>
                          <Button color="primary" variant="contained" size="small" type="submit">
                            Search
                          </Button>
                        </Box>
                      </Box>
                    </CardContent>
                  </form>
                )}
              </Formik>
            </Box>


            {tableData.length !== 0 && (
              <>
                <Box style={{ padding: '4px' }}>
                  <MaterialTable
                    title={
                      <Box display="flex" alignItems="center">
                        <Avatar style={{ marginRight: 16 }}>
                          <DescriptionIcon />
                        </Avatar>
                        <Box>
                          <Typography variant="h5" style={{ fontWeight: 700 }}>
                            Goods Received Notes
                          </Typography>
                          <Typography variant="body2">
                            {getTitleByGRNType(goodsReceiveNote.grnType)}
                          </Typography>
                        </Box>
                      </Box>
                    }
                    columns={[
                      {
                        title: 'GRN Number',
                        field: 'grnNumber',
                        cellStyle: { textAlign: 'left' },
                        headerStyle: { textAlign: 'left' },
                        render: (rowData) => rowData.grnNumber || '-'
                      },
                      {
                        title: 'Date',
                        field: 'receivedDate',
                        cellStyle: { textAlign: 'left' },
                        headerStyle: { textAlign: 'left' },
                        render: (rowData) => moment(rowData.receivedDate).format('YYYY-MM-DD') || '-'
                      },
                      {
                        title: 'Supplier Name',
                        field: 'supplierName',
                        cellStyle: { textAlign: 'left' },
                        headerStyle: { textAlign: 'left' },
                        render: (rowData) => rowData.supplierName || '-'
                      },
                      {
                        title: goodsReceiveNote.grnType === DPO ? 'DPO Number' : 'PO Number',
                        field: 'poNumber',
                        cellStyle: { textAlign: 'left' },
                        headerStyle: { textAlign: 'left' },
                        hidden: goodsReceiveNote.grnType === DGRN,
                        render: (rowData) => rowData.poNumber || '-'
                      },
                      {
                        title: 'Requisition Number',
                        field: 'requisitionNumber',
                        cellStyle: { textAlign: 'left' },
                        headerStyle: { textAlign: 'left' },
                        hidden: goodsReceiveNote.grnType === DPO,
                        render: (rowData) => rowData.requisitionNumber || '-'
                      },
                      {
                        title: 'SKU Name',
                        field: 'skuMasterName',
                        cellStyle: { textAlign: 'left' },
                        headerStyle: { textAlign: 'left' },
                      },
                      {
                        title: 'SKU Code',
                        field: 'skuMasterCode',
                        cellStyle: { textAlign: 'left' },
                        headerStyle: { textAlign: 'left' },
                      },
                      {
                        title: 'Requested Qty',
                        field: 'poQty',
                        cellStyle: { textAlign: 'right' },
                        headerStyle: { textAlign: 'right' },
                        render: (rowData) => formatNumberWithThousandSeparators(rowData.poQty || 0, 2) || '-'
                      },
                      {
                        title: 'Received Qty',
                        field: 'receivedQty',
                        cellStyle: { textAlign: 'right' },
                        headerStyle: { textAlign: 'right' },
                        render: (rowData) => formatNumberWithThousandSeparators(rowData.receivedQty || 0, 2) || '-'
                      },
                      {
                        title: 'Unit Price',
                        field: 'unitPrice',
                        cellStyle: { textAlign: 'right' },
                        headerStyle: { textAlign: 'right' },
                        hidden: goodsReceiveNote.grnType === DGRN,
                        render: (rowData) => formatNumberWithThousandSeparators(rowData.unitPrice || 0, 2)
                      },
                      {
                        title: 'Net Amount',
                        field: 'netAmount',
                        cellStyle: { textAlign: 'right' },
                        headerStyle: { textAlign: 'right' },
                        hidden: goodsReceiveNote.grnType === DGRN,
                        render: (rowData) => formatNumberWithThousandSeparators(rowData.netAmount || 0, 2)
                      },
                      {
                        title: 'Warehouse',
                        field: 'warehouseName',
                        cellStyle: { textAlign: 'left' },
                        headerStyle: { textAlign: 'left' },
                        hidden: goodsReceiveNote.grnType === DPO,
                        render: (rowData) => rowData.warehouseName || '-'
                      },
                    ]}
                    data={tableData}
                    options={{
                      exportButton: false,
                      showTitle: true,
                      headerStyle: {
                        fontWeight: 'bold',
                        textAlign: 'center',
                        height: '50px',
                        fontSize: '14px',
                      },
                      pageSize: 5,
                      pageSizeOptions: [5, 10, 20, 50],
                      paging: true,
                      cellStyle: {
                        textAlign: 'left',
                        fontSize: '13px',
                        padding: '12px 16px'
                      },
                      rowStyle: {
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          background: 'rgba(251, 191, 36, 0.05)',
                          transform: 'translateX(5px)'
                        }
                      },
                      columnResizable: false,
                      actionsColumnIndex: -1
                    }}
                    actions={[
                      {
                        icon: () => <PictureAsPdfIcon style={{ color: '#da180aff' }} />,
                        tooltip: 'Download PDF',
                        onClick: (event, rowData) => {
                          setSelectedGRN({
                            ...rowData,
                          });
                          setTimeout(() => {
                            if (printTriggerRef.current) {
                              printTriggerRef.current.handlePrint();
                            }
                          }, 100);
                        }
                      }
                    ]}
                  />
                  <div style={{ display: 'none' }}>
                    <ReactToPrint
                      ref={printTriggerRef}
                      documentTitle={selectedGRN ? (selectedGRN.grnNumber + ' - Goods Received Note') : 'Goods Received Note'}
                      trigger={() => <button>Print</button>}
                      content={() => printRef.current}
                    />
                    <GoodsReceivedNotePDF ref={printRef} grn={selectedGRN} grnType={goodsReceiveNote.grnType} />
                  </div>
                </Box>
              </>
            )}
          </Card>
        </Container>
      </Page>
    </Fragment>
  );
};

export default GoodReceiveNoteListing;